import Navbar from "@/components/Main/Navbar/Navbar.vue";
import AdMenu from "@/components/Main/AdMenu/AdMenu.vue";
import SideMenu from "@/components/Main/SideMenu/SideMenu.vue";
import CircleSearch from "@/components/Main/CircleSearch/CircleSearch.vue";
import CircleCard from '@/components/Main/Circle/CircleCard.vue'
import CirclePublicList from '@/components/Main/Circle/CirclePublicList.vue'


import Feed from "@/components/Main/Feed/Feed.vue";
import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import InMemoryDb from "@/services/inmemorydb";
import * as constants from "@/constants/index";
import { mapState } from "vuex";

const data = new DataHandlerService()
const content = new ContentService()
const InMemoryDatabase = new InMemoryDb()
const LIMIT = constants.LIMIT

export default {
  name: 'feed',
  props: [],
  components: {
    Navbar,
    AdMenu,
    SideMenu,
    Feed,
    CircleCard,
    CircleSearch,
    CirclePublicList
  },
  data() {
    return {
      user: null,
      page: 0,
      feed: null,
      tempFeed: null,
      contentLoading: true,
      searchCirclesQuery: '',
      recommendedCircles: [],
      userCircles: [],
      publicCircles: null
    };
  },
  created() {
    this.user = data.getUserData();

    this.loadFeed();

    this.$root.$on('fetchMoreContent_Feed', async () => {
      this.contentLoading = true
      this.fetchContentFromAPISinglePage(++this.page)
    })

    this.$root.$on("searchQueryChange", query => this.searchCirclesQuery = query);

    this.$root.$on("NewPostAdded", post => {
      post.type = "media";
      const allFeed = [post, ...(this.tempFeed || [])];

      this.tempFeed = Array.from(new Set(allFeed.map(s => s._id))).map(_id =>
        allFeed.find(s => s._id === _id)
      )
      this.contentLoading = false
      this.feed = [...this.tempFeed]

      InMemoryDatabase.saveFeed(this.tempFeed)
    })

    this.$root.$on('PostModified', post => {
      const postIndex = (this.tempFeed || []).findIndex(s => s._id === post._id)

      if (postIndex > -1) {
        this.tempFeed.splice(postIndex, 1, post)
        this.feed = [...this.tempFeed]
      }
    })

    this.$root.$on('RecommendedCirclesRefreshed', circles => this.recommendedCircles = circles);

    InMemoryDatabase.getRecommendedCircles().then(circles => this.recommendedCircles = circles).catch(() => {});

    this.$root.$on('JoinedCircle', () => {
      const sortedCircles = this.recommendedCircles.sort((a, b) => {
        const [A, B] = [a.member_count, b.member_count];
        if (A < B) {
          return 1;
        }
        if (A > B) {
          return -1;
        }
        return 0;
      });
  
      sortedCircles.map(s => s.joined = this.circles.findIndex(c => c._id === s._id) > -1);
      
      this.selectedRecommendedCircles = sortedCircles.slice(0, 3);
    });

    this.$root.$on('LeftCircle', () => {
      const sortedCircles = this.recommendedCircles.sort((a, b) => {
        const [A, B] = [a.member_count, b.member_count];
        if (A < B) {
          return 1;
        }
        if (A > B) {
          return -1;
        }
        return 0;
      });
  
      sortedCircles.map(s => s.joined = this.circles.findIndex(c => c._id === s._id) > -1);
      
      this.selectedRecommendedCircles = sortedCircles.slice(0, 3);
    });
  },
  computed: {
    ...mapState(['circles']),
    selectedRecommendedCircles: {
      get() {
        if (this.recommendedCircles) {
          const sortedCircles = this.recommendedCircles.sort((a, b) => {
            const [A, B] = [a.member_count, b.member_count];
            if (A < B) {
              return 1;
            }
            if (A > B) {
              return -1;
            }
            return 0;
          });

          sortedCircles.map(s => s.joined = this.circles.findIndex(c => c._id === s._id) > -1);
          
          return sortedCircles.slice(0, 3);
        }
      },
      set(val) {
        return val;
      }
    }
  },
  methods: {
    async fetchContentFromAPISinglePage(page) {
      try {
        const contentFromAPI = await content.readProfileFeed(
          this.user._id,
          page,
          LIMIT
        )
        const allFeed = [...contentFromAPI.content, ...(this.tempFeed || [])]

        this.tempFeed = Array.from(new Set(allFeed.map(s => s._id))).map(_id =>
          allFeed.find(s => s._id === _id)
        )
        this.contentLoading = false
        this.feed = [...this.tempFeed]

        InMemoryDatabase.saveFeed(this.tempFeed)

        if (this.page > contentFromAPI.max) {
          this.page =
            contentFromAPI.content.length < LIMIT
              ? contentFromAPI.max - 1
              : contentFromAPI.max
        }
      } catch (e) {
        /*this.$root.$emit(
          'ShowErrorNotification',
          'An error occurred. Please try again.'
        )*/
      }
    },
    async fetchContentFromAPIMultiPage(max_page) {
      for (let i = 1; i <= max_page; i++) {
        try {
          const temp = [
            ...(await content.readProfileFeed(this.user._id, page, LIMIT)
              .content),
            ...(this.tempFeed || [])
          ]

          if (i === max_page) {
            this.tempFeed = Array.from(new Set(temp.map(s => s._id))).map(_id =>
              temp.find(s => s._id === _id)
            )
            this.contentLoading = false
            this.feed = [...this.tempFeed]
            InMemoryDatabase.saveFeed(this.tempFeed)
          }
        } catch (e) {
          /*this.$root.$emit(
            'ShowErrorNotification',
            'An error occurred. Please try again.'
          )*/
          break
        }
      }
    },
    async loadFeed() {
      try {
        const temp = await InMemoryDatabase.retrieveFeed()
        if (temp.length) {
          this.tempFeed = temp
          this.feed = [...this.tempFeed]
          this.page = Math.round(temp.length / LIMIT)

          if (this.page > 1) {
            this.fetchContentFromAPIMultiPage(this.page)
          } else {
            this.page = 1
            this.fetchContentFromAPISinglePage(this.page)
          }
        } else {
          this.fetchContentFromAPISinglePage(++this.page)
        }
      } catch (e) {
        this.page = 1
        this.fetchContentFromAPISinglePage(this.page)
      }
    },
    loadPublicCircles(circles) {
      this.publicCircles = circles
    }
  }
}
